module.exports = __webpack_public_path__ + "img/samsung-wh.836ba605.svg";